<header>
    <!-- <app-left-menu></app-left-menu> -->
    <div class="container-fluid" (window:beforeunload)="onBeforeUnload()">
        
       
        <div class="row">
            <div class="col-md-9">
                <div class="logo text-center">
                    <img src="assets/images/apps-logo.png" alt="Pon Pure Logistics" />
                </div>
                <a href="javascript:void(0);" class="toggle-btn toggle-menu collapsed text-center">
                    <i class="las la-bars"></i>
                </a>
                <div class="header-search">
                    <p-dropdown name="app-role" [options]="appRoleList" readonly="false" [(ngModel)]="RoleId" (onChange)="changeRole()" optionValue="rolecode" optionLabel="rolename" placeholder="Choose Role">                        
                    </p-dropdown>
                </div>
                <div class="header-search">
                    <p-dropdown name="app-module" [options]="appModuleList" [(ngModel)]="Module" optionLabel="displayname" placeholder="Choose Module">                        
                    </p-dropdown>
                </div>
                <div class="header-search" [hidden]="hiddenMarket">
                    <p-dropdown name="app-module" [options]="appMarketCircleList" [(ngModel)]="MarketCircle" optionLabel="marketCircleName" placeholder="Choose Market Circle">                        
                    </p-dropdown>
                </div>
                <!-- <div class="header-search all" style="float: right;margin-right: 1px;margin-top: 5px;">
                    <p-autoComplete class="quick-search" placeholder="Enter Branch...">
                    </p-autoComplete>
                    <p-dropdown name="app-module" [options]="appMarketCircleList" [(ngModel)]="MarketCircle" optionLabel="marketCircleName" placeholder="Choose Market Circle">                        
                    </p-dropdown>
                </div> -->
            </div>
            <div class="col-md-3 text-right">
                <ul class="navbar-nav">
                    <!-- <li>
                        <div class="dropdown">
                            <a href="javascript:void(0);" class="toggle-btn text-center" data-toggle="dropdown" id="userLogout1">
                                <span class="badges">10</span>
                                <i class="las la-bell"></i>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userLogout1">
                                <ul class="notification">
                                    <li>
                                        <h6>Report Created Successfully</h6>
                                        <small>31 Oct 2020 - 02:20 PM</small>
                                    </li>
                                    <li>
                                        <h6>Report Created Successfully</h6>
                                        <small>31 Oct 2020 - 02:20 PM</small>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li> -->
                    <li>
                        <div class="dropdown user-logout">
                            <a href="javascript:void(0);" class="user-profile txt-center" data-toggle="dropdown" id="userLogout">
                                <img src="assets/images/avatar.png" alt="" class="img-fluid">
                                <div class="header-info text-left">
                                    <span><strong>{{username}}</strong></span>
                                    <!-- <small>Project Manager</small> -->
                                </div>
                            </a>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userLogout">
                                <ul class="dropdown-user">
                                    <!-- <li><a href="#"><i class="las la-lock"></i>Change Password</a></li> -->
                                    <li><a href="javascript:void(0);" class="karthikdev" (click)="OnLogout()"><i class="las la-sign-out-alt"></i>Logout</a></li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>                
            </div>
        </div>
    </div>
</header>
<!--<div class="network-status white">
    <a href="javascript:void(0);" class="network-close">&times;</a>
    <div class="network-icon down"></div>
    <div class="network-text">Network Down. Save your data in Local DB.....</div>
</div>
<div class="network-status white" style="display:none;">
    <a href="javascript:void(0);" class="network-close">&times;</a>
    <div class="network-icon up"></div>
    <div class="network-text">Network Came. You can resume your Work.....</div>
</div>-->
<p-dialog class="approval-notification send-approval" [style]="{width: '300px'}" position="bottom-right">
    <ng-template pTemplate="header">
        <div class="approval-hdr">
            Approval Notification
        </div>
    </ng-template>
    <div class="approval-body">
        <img src="../../assets/images/chart02.jpg" alt="" class="img-preview">
        <div class="img-text">
            <p>User01 requesting approval for Product Name</p>
        </div>
        <table>
            <tr>
                <td colspan="2">
                    <label>Name</label>
                    <div class="text">Product Name</div>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <label>Category</label>
                    <div class="text">Category Name</div>
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <label>Price</label>
                    <div class="text">$120</div>
                </td>
            </tr>
        </table>
    </div>
    <p-footer>
        <textarea pInputTextarea [rows]="2"></textarea>
        <div class="approval-ftr">
            <div class="text-center">
                <button class="p-button p-button-success" title="Approve">
                    <i class="las la-check"></i>
                </button>
                <button class="p-button p-button-warning" title="Reject">
                    <i class="pi pi-ban"></i>
                </button>
                <button class="p-button" title="View">
                    <i class="pi pi-eye"></i>
                </button>
            </div>
        </div>
    </p-footer>
</p-dialog>
<p-dialog [(visible)]="displayChat" class="approval-notification chat-window" [style]="{width: '300px'}" position="bottom-right">
    <ng-template pTemplate="header">
        <div class="approval-hdr">
            Chat
        </div>
    </ng-template>
    <div class="chat-body">
        <div class="comment-section text-right">
            <div class="comment02">
                <label>Me</label>
                <div class="text">Are you there?</div>
            </div>
        </div>
        <div class="comment-section">
            <div class="comment01">
                <label>Supervisor Name</label>
                <div class="text">Yes...</div>
            </div>
        </div>
        <div class="comment-section text-right">
            <div class="comment02">
                <label>Me</label>
                <div class="text">Need quick approval from your end...</div>
            </div>
        </div>
        <div class="comment-section">
            <div class="comment01">
                <label>Supervisor Name</label>
                <div class="text">Yes. Please....</div>
            </div>
        </div>
        <div class="comment-section text-right">
            <div class="comment02">
                <label>Me</label>
                <div class="text">Customer wants some number of items which is out of stock. Shall I proceed?</div>
            </div>
        </div>
        <div class="comment-section">
            <div class="comment01">
                <label>Supervisor Name</label>
                <div class="text">Yes... You can... I will look up and forward it to some of branches and let you know....</div>
            </div>
        </div>
        <div class="comment-section text-right">
            <div class="comment02">
                <label>Me</label>
                <div class="text">Ok... Thanks...</div>
            </div>
        </div>
    </div>
    <p-footer>
        <div class="chat-ftr">
            <div class="chat-input-area">
                <textarea pInputTextarea [rows]="2"></textarea>
                <button class="p-button" title="Send">
                    <i class="pi pi-arrow-up"></i>
                </button>
            </div>
        </div>
    </p-footer>
</p-dialog>
<p-dialog header="Session Expired" [modal]="true" (onHide)="OnLogout()" [(visible)]="SessionPopup" class="approval-notification session-expiry" [style]="{width: '300px'}">
    <div class="approval-body">
        <p><strong>Your Session has been Expired.</strong></p>
        <div class="text-center">
            <button pButton (click)="OnLogout()" class="maroon">Back To Login</button>
            <!-- <p-button (click)="OnLogout()" class="maroon">Back To Login</p-button> -->
        </div>
    </div>
  </p-dialog>
